import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Routes, Route, Navigate } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Industries from "./pages/Industries";
import IndustryDetail from "./pages/IndustryDetail";
import SubcategoryDetail from "./pages/SubcategoryDetail";
import Partners from "./pages/Partners";
import Support from "./pages/Support";
import Contact from "./pages/Contact";
import Company from "./pages/Company";
import People from "./pages/company/People";
import History from "./pages/company/History";
import Experience from "./pages/company/Experience";
import Certifications from "./pages/company/Certifications";
import CertificationsPage from "./pages/Certifications";
import Careers from "./pages/company/Careers";
import Privacy from "./pages/legal/Privacy";
import Terms from "./pages/legal/Terms";
import Cookies from "./pages/legal/Cookies";
import NotFound from "./pages/NotFound";
// Admin imports - uncomment to reactivate admin dashboard
// import AdminLogin from "./pages/admin/Login";
// import AdminDashboard from "./pages/admin/Dashboard";
import Presentation from "./pages/Presentation";
import Resources from "./pages/Resources";

const App = () => (
  <TooltipProvider>
    <ScrollToTop />
    <Toaster />
    <Sonner />
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/company" element={<Company />} />
      <Route path="/company/history" element={<History />} />
      <Route path="/company/people" element={<People />} />
      <Route path="/company/experience" element={<Experience />} />
      <Route path="/company/certifications" element={<Certifications />} />
      <Route path="/company/careers" element={<Careers />} />
      <Route path="/industries" element={<Industries />} />
      <Route path="/industries/:industrySlug/:subcategorySlug" element={<SubcategoryDetail />} />
      <Route path="/industries/:slug" element={<IndustryDetail />} />
      <Route path="/partners" element={<Partners />} />
      <Route path="/support" element={<Support />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/legal/terms" element={<Terms />} />
      <Route path="/legal/cookies" element={<Cookies />} />
      {/* Admin routes - uncomment to reactivate admin dashboard */}
      {/* <Route path="/admin/login" element={<AdminLogin />} /> */}
      {/* <Route path="/admin" element={<AdminDashboard />} /> */}
      <Route path="/presentation" element={<Presentation />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/certifications" element={<CertificationsPage />} />
      {/* Redirects for old URLs */}
      <Route path="/efkairies-karieras" element={<Navigate to="/company/careers" replace />} />
      <Route path="/efkairies-karieras/" element={<Navigate to="/company/careers" replace />} />
      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </TooltipProvider>
);

export default App;
